import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactDOM from "react-dom";
import "../modal.css";
import { toast } from "react-toastify";
import { useState } from "react";
import { useDistributorStore } from "../../../store/useDistributorStore";
import { useEffect } from "react";
import { Eye, EyeOff } from 'lucide-react';
// import { useDistributor } from "../../../store/useDistributor";

const AddDistributorPopup = ({ onClose, fetchData, filter, editData = {}, setCurrentPage }) => {

// console.log(editData , 'editData')

const { fetchStatesList,fetchDistrictsList,createDistributor, editDistributor } = useDistributorStore();
const [showPassword, setShowPassword] = useState(false);

  const isEditing = Object.keys(editData).length > 0;

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const fetchStates = async () => {
    const res = await fetchStatesList()

    if(res.status) {
      setStates(res.data)
    }
  }

  const fetchDistricts = async (state_id) => {
    let params = {state_id : state_id}
    const res = await fetchDistrictsList(params)

    if(res.status) {
      setDistricts(res.data)
    }
  }

  const handleCreateDistributor = async (values) => {
    try {
      const response = await createDistributor(values);
      console.log(response , 'add response')
      if (response.status) {
        toast.success("Distributor added successfully!", {toastId: 'successMessageCreateDist'});
        onClose();
        fetchData(filter);
        setCurrentPage(1)
      } else {
        toast.error(response?.data?.data?.message ?? "Failed to Add distributor", {toastId: 'errorMessageCreateDistr'});
      }
    } catch (e) {
      console.log(e)
    }
  };

  const handleEditDistributor = async (values) => {
    const updatedValues = { ...values, user_id: editData?.user_id };
    try {
      const response = await editDistributor(updatedValues);
      if (response.status) {
        toast.success("Distributor updated successfully!", {toastId: 'successMessageEditDistr'});
        onClose();
        fetchData(filter);
        setCurrentPage(1)
      } else {
        toast.error(response?.data?.data?.message ?? "Failed to update distributor", {toastId: 'errorMessageEditDistr'});
      }
    } catch (e) {
      console.log(e)
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: editData?.firstName ?? "",
      lastName: editData?.lastName ?? "",
      mobile: editData?.mobile ?? "",
      email: editData?.email ?? "",
      password: "",
      distributor_name: editData?.distributor_name ?? "",
      gst_number : editData?.gst_number || "",
      contact_person: editData?.contact_person ?? "",
      address: editData?.address ?? "",
      state_id: editData?.state_id ?? "",
      district_id: editData?.district_id ?? "",
      block_user: editData?.block_user === "0" ? "0" : "1",
      distributor_code: editData?.distributor_code ?? "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      mobile: Yup.string().matches(/\d{10}/, "Enter a valid 10-digit mobile number").required("Mobile number is required"),
      email: Yup.string().email("Enter a valid email").required("Email is required"),
      password: isEditing
      ? Yup.string().notRequired()
      : Yup.string()
          .min(6, "Password must be at least 6 characters")
          .required("Password is required"),
      distributor_name: Yup.string().required("Distributor name is required"),
      contact_person: Yup.string().required("Contact person is required"),
      gst_number : Yup.string()
          .min(15,'GST must contain 15 characters')
          .max(15,'GST must contain 15 characters')
          .required("GST number is required"),
      address: Yup.string().required("Address is required"),
      state_id: Yup.string().required("State is required"),
      district_id: Yup.string().required("District is required"),
      distributor_code: Yup.string().required("Distributor code is required"),
    }),
    onSubmit: (values) => {
      isEditing ? handleEditDistributor(values) : handleCreateDistributor(values);
    },
  });

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    if (formik.values.state_id) {
      fetchDistricts(formik.values.state_id);
    } else {
      setDistricts([]);
    }
  }, [formik.values.state_id]);

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" 
      // onClick={onClose}
      ></div>
      <div className="custom-modal w-[70%]">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">
              {isEditing ? "Edit Distributor" : "Add Distributor"}
            </h5>
            <button className="custom-close-btn" onClick={onClose}>
              &times;
            </button>
          </div>
          <div className="custom-modal-body">
            <form
              onSubmit={formik.handleSubmit}
              className="grid grid-cols-3 gap-4"
            >
              <div className="relative">
                <label className="block mb-1">First Name</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("firstName")}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                    formik.handleChange(e);
                  }}
                />
                {formik.touched.firstName && formik.errors.firstName && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.firstName}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block mb-1">Last Name</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("lastName")}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                    formik.handleChange(e);
                  }}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.lastName}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block mb-1">Mobile</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("mobile")}
                  onChange={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    formik.handleChange(e);
                  }}
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.mobile}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block mb-1">Email</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("email")}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              {!isEditing && (
                <div className="relative">
                  <label className="block mb-1">Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="custom-input"
                    {...formik.getFieldProps("password")}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500 focus:outline-none"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                  {formik.touched.password && formik.errors.password && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.password}
                    </div>
                  )}
                </div>
              )}

              <div className="relative">
                <label className="block mb-1">Distributor Shop Name</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("distributor_name")}
                />
                {formik.touched.distributor_name &&
                  formik.errors.distributor_name && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.distributor_name}
                    </div>
                  )}
              </div>

              <div className="relative">
                <label className="block mb-1">Distributor Code</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("distributor_code")}
                />
                {formik.touched.distributor_code &&
                  formik.errors.distributor_code && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.distributor_code}
                    </div>
                  )}
              </div>

              <div className="relative">
                <label className="block mb-1">GST No.</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("gst_number")}
                  onChange={(e) => {
                    // e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                    formik.handleChange(e);
                  }}
                />
                {formik.touched.gst_number &&
                  formik.errors.gst_number && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.gst_number}
                    </div>
                  )}
              </div>

              <div className="relative">
                <label className="block mb-1">Contact Person Name</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("contact_person")}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
                    formik.handleChange(e);
                  }}
                />
                {formik.touched.contact_person &&
                  formik.errors.contact_person && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.contact_person}
                    </div>
                  )}
              </div>

              <div className="relative">
                <label className="block mb-1">Address</label>
                <input
                  type="text"
                  className="custom-input"
                  {...formik.getFieldProps("address")}
                />
                {formik.touched.address && formik.errors.address && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.address}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block mb-1">State</label>
                <select
                  className="custom-input"
                  {...formik.getFieldProps("state_id")}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state.state_id} value={state.state_id}>
                      {state.state_name}
                    </option>
                  ))}
                </select>
                {formik.touched.state_id && formik.errors.state_id && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.state_id}
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="block mb-1">District</label>
                <select
                  className="custom-input"
                  {...formik.getFieldProps("district_id")}
                  disabled={!formik.values.state_id}
                >
                  <option value="">Select District</option>
                  {districts.map((district) => (
                    <option key={district.id} value={district.id}>
                      {district.name}
                    </option>
                  ))}
                </select>
                {formik.touched.district_id && formik.errors.district_id && (
                  <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                    {formik.errors.district_id}
                  </div>
                )}
              </div>
              {isEditing && (
                <div className="relative mb-4">
                  <label className="mt-2">Status</label>
                  <select
                    className="custom-input mt-2"
                    {...formik.getFieldProps("block_user")}
                  >
                    <option value="0">Active</option>
                    <option value="1">Blocked</option>
                  </select>
                  {formik.touched.block_user && formik.errors.block_user && (
                    <div className="absolute -bottom-5 text-red-500 text-sm mt-1">
                      {formik.errors.block_user}
                    </div>
                  )}
                </div>
              )}

              {/* Buttons */}
              <div className="col-span-3 flex justify-end gap-1 mt-4">
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto"
                >
                  {isEditing ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default AddDistributorPopup;
